import {SCENARIO_LINE_MAX_SYMBOLS_COUNT} from "../constants";

export function isTooLong(line) {
  return line.text.length > SCENARIO_LINE_MAX_SYMBOLS_COUNT;
}
